/*
  Theme: the reviews page, filter / sort / paging.

  ⚠️ EVERY REVIEW IS ALREADY ON THE PAGE. Liquid server-renders all of them from
  the ats.reviews metafield, newest first, before this file runs. Nothing here
  fetches, builds or reorders data: it hides and shows cards that already exist.

  THE NO-JS STATE IS THE ONE THE SERVER SHIPS, and it is complete: every review
  visible, correctly ordered, nothing broken. What is missing without this
  script is only the ability to filter, sort and paginate, so the controls for
  those ship `hidden` and this file un-hides them. Same inversion as the returns
  form's Add button and for the same reason: never render a control that cannot
  work.

  So on boot this script makes the page WORSE in one specific way, deliberately:
  it collapses 200 visible reviews down to the concept's page size of 9 and puts
  a Load more button under them. That is the designed experience; the full list
  is the graceful degradation, not the target.

  ⚠️ THE CLAMP IS APPLIED HERE, NOT IN LIQUID, and that is the no-JS invariant
  again. The server ships every body in full and every Show more hidden, so with
  no script a reader gets complete reviews and no dead controls. On boot this
  file adds the clamp class, measures which cards actually overflow, and reveals
  a control only on those. A card whose text fits never grows a button.

  ⚠️ SORTING REORDERS DOM NODES, IT DOES NOT REBUILD THEM. The cards carry
  data-rating and data-date, so no rendered text is ever parsed back. data-date
  is the raw ISO string from the metafield, which compares correctly as a plain
  string, so no Date objects are constructed either.
*/
(function () {
  'use strict';

  /* The concept's page size. Its PER is 9, a clean 3 x 3 on the desktop grid. */
  var PAGE = 9;

  function init(root) {
    if (!root || root.dataset.rvReady === 'true') return;

    var grid = root.querySelector('[data-rv-grid]');
    var tools = root.querySelector('[data-rv-tools]');
    if (!grid || !tools) return;

    root.dataset.rvReady = 'true';

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.rv'));
    var empty = grid.querySelector('[data-rv-empty]');
    var moreWrap = root.querySelector('[data-rv-more]');
    var moreBtn = root.querySelector('[data-rv-loadmore]');
    var pills = root.querySelector('[data-rv-pills]');
    var bars = root.querySelector('[data-rv-bars]');
    var sortBtn = root.querySelector('[data-rv-sortbtn]');
    var sortMenu = root.querySelector('[data-rv-sortmenu]');
    var sortCurrent = root.querySelector('[data-rv-sortcurrent]');

    var filter = 0; /* 0 = all */
    var sort = 'recent';
    var shown = PAGE;

    /* Read once. Sorting then works on numbers and strings rather than
       re-reading attributes on every comparison. */
    var model = cards.map(function (el, i) {
      return {
        el: el,
        rating: Number(el.getAttribute('data-rating')) || 0,
        date: el.getAttribute('data-date') || '',
        /* Original index preserves the metafield's own order as the final
           tiebreak, so equal ratings and equal dates never shuffle. */
        i: i,
      };
    });

    function matching() {
      var list = model.filter(function (m) {
        return !filter || m.rating === filter;
      });
      if (sort === 'high') {
        list.sort(function (a, b) {
          return b.rating - a.rating || (a.date < b.date ? 1 : a.date > b.date ? -1 : a.i - b.i);
        });
      } else if (sort === 'low') {
        list.sort(function (a, b) {
          return a.rating - b.rating || (a.date < b.date ? 1 : a.date > b.date ? -1 : a.i - b.i);
        });
      } else {
        list.sort(function (a, b) {
          return a.date < b.date ? 1 : a.date > b.date ? -1 : a.i - b.i;
        });
      }
      return list;
    }

    function render() {
      var list = matching();

      /* Hide everything, then show the page. Cheaper to reason about than
         diffing, and at 200 nodes the cost is not measurable. */
      for (var i = 0; i < model.length; i++) model[i].el.hidden = true;

      var page = list.slice(0, shown);
      for (var j = 0; j < page.length; j++) {
        page[j].el.hidden = false;
        /* order on a grid item reorders visually without touching the DOM, so
           the tab order and the reading order stay as rendered. */
        page[j].el.style.order = String(j);
      }

      if (empty) empty.hidden = list.length !== 0;
      if (moreWrap) moreWrap.hidden = shown >= list.length;

      /* Every render re-measures, so a load-more batch arrives clamped with
         working controls and a filter change cannot leave a stale button on a
         card that no longer overflows at its new position. */
      applyClamp();
      syncActive();
    }

    function syncActive() {
      var all = root.querySelectorAll('[data-star]');
      for (var i = 0; i < all.length; i++) {
        var v = Number(all[i].getAttribute('data-star'));
        all[i].classList.toggle('on', v === filter);
      }
    }

    /* Clicking the active filter clears it, which is how the concept behaves. */
    function setFilter(n) {
      filter = filter === n ? 0 : n;
      shown = PAGE;
      render();
    }

    function onFilterClick(e) {
      var btn = e.target.closest ? e.target.closest('[data-star]') : null;
      if (!btn) return;
      setFilter(Number(btn.getAttribute('data-star')));
    }

    if (pills) pills.addEventListener('click', onFilterClick);
    if (bars) bars.addEventListener('click', onFilterClick);

    function closeMenu() {
      if (!sortMenu) return;
      sortMenu.classList.remove('on');
      if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
    }

    if (sortBtn && sortMenu) {
      sortBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = sortMenu.classList.toggle('on');
        sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      sortMenu.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-sort]') : null;
        if (!b) return;
        sort = b.getAttribute('data-sort');
        shown = PAGE;
        var opts = sortMenu.querySelectorAll('[data-sort]');
        for (var i = 0; i < opts.length; i++) opts[i].classList.toggle('sel', opts[i] === b);
        if (sortCurrent) sortCurrent.textContent = b.textContent.trim();
        closeMenu();
        render();
      });
      /* Click-away and Escape, so the menu is not a trap. */
      document.addEventListener('click', closeMenu);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMenu();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        shown += PAGE;
        render();
      });
    }

    /* ---- clamp + per-card expansion ---------------------------------- */

    var LBL_MORE = root.getAttribute('data-rv-more-label') || 'Show more';
    var LBL_LESS = root.getAttribute('data-rv-less-label') || 'Show less';

/* ⚠️ THE CLAMP IS THE PDP DESCRIPTION'S TRIM, PORTED, NOT A CSS LINE-CLAMP.
       assets/core-product.js measures a BLOCK, binary-searches the longest prefix
       that still fits N lines, cuts at a word boundary and appends a real
       ellipsis, with the toggle flowing inline straight after it. That is what
       runs here now, at `clamp_lines` lines instead of the description's two.

       WHY A TRIM RATHER THAN -webkit-line-clamp, and it is the same reason
       recorded on the PDP: a CSS clamp leaves half-visible letters behind an
       overlaid control and reads as a rendering fault. A trim cuts the string,
       so nothing is covered because nothing overlaps.

       ⚠️ THE TOGGLE MUST BE LAID OUT WHILE MEASURING. If it is hidden during
       the search, the last line has room the real layout will not have and the
       clamp overshoots by roughly the width of the word "Show more".

       ⚠️ MULTI-PARAGRAPH BODIES FLATTEN WHILE CLAMPED AND COME BACK ON EXPAND.
       Fixture #006 is three paragraphs. A trim needs one measurable run, so the
       collapsed view is a single flattened paragraph ending "...word\u2026Show
       more" wherever the cut lands, mid-paragraph or not. Expanding restores the
       ORIGINAL markup, paragraph breaks included, and moves the toggle inline
       after the last one. The alternative, clamping each paragraph separately,
       is the fault already recorded against -webkit-line-clamp: it gives every
       paragraph its own N lines.

       ⚠️ EXPANSION DOES NOT SURVIVE A RE-RENDER, and that is deliberate and
       unchanged: a filter, a sort or a load-more re-clamps every visible card,
       so a card cannot be left expanded and mismeasured behind a new query. */
    function bodyText(card) {
      var stash = card.getAttribute('data-rv-full');
      if (stash === null) {
        var body = card.querySelector('[data-rv-body]');
        card.setAttribute('data-rv-html', body.innerHTML);
        /* ⚠️ JOIN THE PARAGRAPHS WITH A SPACE. `body.textContent` concatenates
           them with nothing between, so fixture #006 flattened to
           "...paragraph breaks.All three..." with the full stop welded to the
           next sentence. Caught in the rendered screenshot, not in review. */
        var ps = body.querySelectorAll('p');
        stash = (ps.length ? Array.prototype.map.call(ps, function (n) { return n.textContent; }).join(' ') : body.textContent)
          .replace(/\s+/g, ' ')
          .trim();
        card.setAttribute('data-rv-full', stash);
      }
      return stash;
    }

    function lineHeightOf(el) {
      var lh = parseFloat(getComputedStyle(el).lineHeight);
      return isNaN(lh) ? 22 : lh;
    }

    /* How many lines this card is allowed, from the --rv-clamp custom property
       the section writes from its clamp_lines setting. One source of truth. */
    function clampLines(card) {
      var v = parseInt(getComputedStyle(card).getPropertyValue('--rv-clamp'), 10);
      return v > 0 ? v : 4;
    }

    function renderBody(card) {
      var body = card.querySelector('[data-rv-body]');
      if (!body) return;

      /* ⚠️ DROP THE BORN-CLAMPED CLASS BEFORE MEASURING. The markup ships with
         .rv-body--clamp so no card is painted at full height on a cold load;
         from here the exact trim below owns the collapsed state. Leaving it on
         would cap scrollHeight, so every fit test would pass and no card would
         ever grow a control, AND it would clamp the EXPANDED state too, which
         is the one branch that must never be capped.

         It is removed here rather than once at boot because a card can be
         re-rendered by load-more, a filter or a sort, and only the cards
         actually rendered have had their class taken off. Cards still hidden
         keep it, which is exactly right: they are the ones that have not been
         measured yet. */
      body.classList.remove('rv-body--clamp');

      var full = bodyText(card);
      if (!full) return;
      var lines = clampLines(card);
      var expanded = card.getAttribute('data-rv-expanded') === 'true';

      if (expanded) {
        /* Original markup back, paragraphs and curly quotes intact, with the
           toggle inline after the last paragraph so it reads the same way it
           does when collapsed. */
        body.innerHTML = card.getAttribute('data-rv-html');
        var last = body.lastElementChild || body;
        last.appendChild(makeToggle(LBL_LESS, true));
        return;
      }

      body.innerHTML = '<p class="rv-body__trim"><span data-rv-trim></span></p>';
      var para = body.firstElementChild;
      var span = para.querySelector('[data-rv-trim]');
      var btn = makeToggle(LBL_MORE, false);
      para.appendChild(btn);

      /* ⚠️ MEASURE THE PARAGRAPH, NOT THE WRAPPER, AND THE FIRST PORT GOT THIS
         WRONG. `.rv-body` is an unstyled div whose computed line-height comes
         from the card, while the paragraph inside carries the concept's own
         1.8. Multiplying the WRAPPER's smaller line-height by the line count
         gave a budget well under four real lines, and the cards clamped to
         about two. The PDP does not have this problem because there the
         measured block IS the styled paragraph. */
      span.textContent = full;
      if (para.scrollHeight <= lineHeightOf(para) * lines + 1) {
        /* Short enough already: no toggle and no ellipsis, so a two-line review
           never carries a dead control. The original markup goes back so the
           paragraph structure is not silently lost on short bodies. */
        body.innerHTML = card.getAttribute('data-rv-html');
        return;
      }

      var lo = 0, hi = full.length, best = 0;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        span.textContent = full.slice(0, mid).replace(/\s+\S*$/, '') + '\u2026';
        if (para.scrollHeight <= lineHeightOf(para) * lines + 1) { best = mid; lo = mid + 1; }
        else { hi = mid - 1; }
      }
      span.textContent = full.slice(0, best).replace(/\s+\S*$/, '') + '\u2026';
    }

    /* Labels come from the section settings via the root's data attributes, the
       same two the old block-button build read. aria-expanded is set because the
       control genuinely discloses content, and a screen reader otherwise hears
       only a label change. */
    function makeToggle(label, isExpanded) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rv-expand';
      b.setAttribute('data-rv-expand', '');
      b.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      b.textContent = label;
      return b;
    }

    function applyClamp() {
      for (var i = 0; i < model.length; i++) {
        var card = model[i].el;
        if (card.hidden) continue;
        card.setAttribute('data-rv-expanded', 'false');
        renderBody(card);
      }
    }

    grid.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('[data-rv-expand]') : null;
      if (!btn) return;
      var card = btn.closest('.rv');
      if (!card) return;
      /* THIS CARD ONLY. Siblings keep their trim and their pinned bylines; the
         row simply grows to the tallest card, which is the grid doing its job. */
      card.setAttribute('data-rv-expanded', card.getAttribute('data-rv-expanded') === 'true' ? 'false' : 'true');
      renderBody(card);
    });

    /* The available width decides where N lines end, so a resize re-trims.
       Debounced, exactly as the PDP description does it. */
    var rvResize;
    window.addEventListener('resize', function () {
      clearTimeout(rvResize);
      rvResize = setTimeout(applyClamp, 120);
    });

    /* THE TRADE. The server shipped every review visible and the controls
       hidden; swap to the designed experience now that the script is running. */
    tools.hidden = false;
    render();
  }

  function boot() {
    try {
      var roots = document.querySelectorAll('.core-reviews');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    } catch (e) {
      /* A page that fails to enhance is the full list of reviews in the right
         order. Never take the reviews page down for a filter control. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
